/**
 * App Content Component
 *
 * Main content area with routing for the admin interface.
 *
 * @since 1.0.0
 */

import { Flex } from '@redfoxwp/core-components/components/flex';
import { FlexItem } from '@redfoxwp/core-components/components/flex-item';
import { __ } from '@wordpress/i18n';
import { Route, Switch } from 'wouter';

import { useSettingsContext } from '../../contexts/settings-context';
import { Navigation } from '../navigation';
import { NotificationsContainer } from '../notifications-container';
import { PageWrapper } from '../page-wrapper';
import { AdvancedSettings, DisplaySettings, GeneralSettings, StylingSettings } from '../settings';

// Route configuration for cleaner maintenance
const routes = [
  {
    path: '/',
    title: __('General Settings', 'redfox-added-to-cart-popup'),
    component: GeneralSettings,
  },
  {
    path: '/display',
    title: __('Display Settings', 'redfox-added-to-cart-popup'),
    component: DisplaySettings,
  },
  {
    path: '/styling',
    title: __('Styling Settings', 'redfox-added-to-cart-popup'),
    component: StylingSettings,
  },
  {
    path: '/advanced',
    title: __('Advanced Settings', 'redfox-added-to-cart-popup'),
    component: AdvancedSettings,
  },
];

/**
 * App Content component
 *
 * @since 1.0.0
 *
 * @return JSX element.
 */
export const AppContent = (): JSX.Element => {
  const { notifications, dismissNotification } = useSettingsContext();

  return (
    <>
      <Flex direction='row' gap='30px' fullWidth>
        <FlexItem flex='0 0 300px'>
          <Navigation />
        </FlexItem>
        <FlexItem flex='1' maxWidth='900px'>
          <Switch>
            {routes.map((route) => {
              const Component = route.component;
              return (
                <Route key={route.path} path={route.path}>
                  <PageWrapper title={route.title}>
                    <Component />
                  </PageWrapper>
                </Route>
              );
            })}
          </Switch>
        </FlexItem>
      </Flex>
      <NotificationsContainer notifications={notifications ?? []} onDismiss={dismissNotification} />
    </>
  );
};
